import { UPDATE_TOOL_TYPE } from "../reduxConst/toolTypeConst";

export const updateToolType = (data) => {
  return {
    type: UPDATE_TOOL_TYPE,
    data
  }
}